import React from 'react'
import { Row, Col } from 'react-bootstrap'
import AnalyticsFilters from './analytics'
import Button from 'react-bootstrap/Button'

function DashboardFilters({
  params,
  setParams,
  isFilterOpen,
  setIsFilterOpen,
  showStats,
  setShowStats,
  showAnalytics = true,
  disabled = false
}) {
  const rowStyle = disabled ? { pointerEvents: 'none', opacity: 0.6 } : {}

  return (
    <Row style={rowStyle}>
      {showAnalytics && (
        <Col sm="auto">
          <AnalyticsFilters
            params={params}
            setParams={setParams}
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
          />
        </Col>
      )}
      {false && (
        <Col className="ml-auto text-right">
          <Button variant="link" onClick={() => setShowStats(!showStats)}>
            {showStats ? 'Hide' : 'Show'} Stats
          </Button>
        </Col>
      )}
    </Row>
  )
}

export default DashboardFilters
